import { css } from '@emotion/react'
import StaticMapService, {
  GeoJsonOverlay
} from '@mapbox/mapbox-sdk/services/static'
import { useMemo } from 'react'
import Selected from 'assets/icons/selected-3.svg'
import {
  getCenterZoomFromBounds,
  StaticMapDiv
} from 'containers/seoPages/map/SearchStaticMap'
import { StaticMapDisplay } from './StaticMapDisplay'
import { NEXT_PUBLIC_MAPBOX_TOKEN } from './map-env'

interface Props {
  longitude: number
  latitude: number
  geoJson?: GeoJsonOverlay
  pointerEventsNone: boolean
  onMouseDown: () => void
  bounds?: [number, number, number, number] | null
  mapRef: React.RefObject<HTMLDivElement | null>
}

const staticMapService = StaticMapService({
  accessToken: NEXT_PUBLIC_MAPBOX_TOKEN
})

const calculateMapPosition = (
  bounds: [number, number, number, number] | null | undefined,
  width: number,
  height: number,
  latitude: number,
  longitude: number
): { coordinates: [number, number]; zoom: number } => {
  if (bounds) {
    const { center, zoom } = getCenterZoomFromBounds(bounds, width, height, 50)
    return { coordinates: center, zoom }
  }
  return {
    coordinates: [longitude, latitude],
    zoom: 11.35
  }
}

export const StaticMap = ({
  latitude,
  longitude,
  onMouseDown,
  pointerEventsNone,
  geoJson,
  bounds,
  mapRef
}: Props) => {
  const staticMapUrl = useMemo(() => {
    if (!mapRef.current) {
      return ''
    }
    const { width: imageWidth, height: imageHeight } =
      mapRef.current.getBoundingClientRect()

    const position = calculateMapPosition(
      bounds,
      imageWidth,
      imageHeight,
      latitude,
      longitude
    )

    const staticImageRequest = staticMapService.getStaticImage({
      position,
      ...(geoJson
        ? {
            overlays: [
              ...[geoJson],
              {
                marker: {
                  url: 'https://peyce.s3.eu-west-3.amazonaws.com/selected-3.png',
                  coordinates: [longitude, latitude]
                }
              }
            ]
          }
        : {}),
      ownerId: 'peyce',
      styleId: 'cl30azfve005k14qnod0isbro',
      height: Math.round(Math.min(1280, imageHeight)),
      width: Math.round(imageWidth),
      highRes: true
    })
    return staticImageRequest.url()
  }, [latitude, longitude, bounds, mapRef])
  return (
    <StaticMapDiv pointerEventsNone={pointerEventsNone}>
      <StaticMapDisplay onMouseDown={onMouseDown} staticMapUrl={staticMapUrl} />
      {!bounds && (
        <div
          css={css`
            position: absolute;
            left: 50%;
            top: 50%;
            margin-top: -52px;
            margin-left: -21px;
            pointer-events: none;
          `}
        >
          <Selected
            css={css`
              margin-bottom: 46px;
              width: 42px !important;
            `}
          />
        </div>
      )}
    </StaticMapDiv>
  )
}
